import classNames from "classnames";
import React, { FunctionComponent } from "react";

import { Text } from "@/components/Text";
import { Badge, Flex, IBadgeProps, Section } from "@/eworkitComponents";
import { TColorVariant } from "@/style/colorVariants";

export interface ISkillLevelProps extends IBadgeProps {
  text: string;
  levelText?: string;
  textColor?: TColorVariant;
}

const baseClass = "skill-level";

export const SkillLevel: FunctionComponent<ISkillLevelProps> = props => {
  const { text, levelText, textColor = "black", ...badgeProps } = props;

  const classes = classNames(baseClass, "-overflow-hidden", {
    [`${baseClass}--has-level`]: !!levelText,
  });

  return (
    <Badge className={classes} {...badgeProps} border>
      <Flex innerMargin="sm" padding={["xss", false]} wrap="wrap">
        <Text color={textColor} ellipsis wordBreak="word" whiteSpace="normal">
          {text}
        </Text>
        {levelText && (
          <Section className={`${baseClass}__level`} background="secondary">
            <Text color="grey2" text={`(${levelText})`} ellipsis wordBreak="word" whiteSpace="normal" />
          </Section>
        )}
      </Flex>
    </Badge>
  );
};
